import { shopifyFetch } from "../shopifyFetch";
import { GET_PRODUCT_RECOMMANDATIONS } from "./queries";

export default class ProductRecommendationsApi {
    /**
     * Get product recommendations
     *  @param {string} : productId 
     *  @return {promise} : Product Array
     */
    static async getProductRecommendations(productId) {
        console.log('%c [ProductRecommendationsApi - getProductRecommendations] - getProductRecommendations', 'color: #849324');
        try {
            const response = await shopifyFetch({
                query: GET_PRODUCT_RECOMMANDATIONS,
                variables: {
                    productId
                },
            });

            return response?.productRecommendations;

        } catch (error) {
            console.log('%c [ProductRecommendationsApi - getProductRecommendations]', 'color: #fd151b', error);
        }
    }
}